export const sortOptions = [
    { value: 'date-old', label: 'GRANTS.MITI_LANDING.SORT.DATE_OLD' },
    { value: 'date-new', label: 'GRANTS.MITI_LANDING.SORT.DATE_NEW' },
    {
        value: 'fund-low-high',
        label: 'GRANTS.MITI_LANDING.SORT.FUND_LOW_TO_HIGH',
    },
    {
        value: 'fund-high-low',
        label: 'GRANTS.MITI_LANDING.SORT.FUND_HIGH_TO_LOW',
    },
];

export const filtersOptions = [
    {
        id: 'bo',
        name: 'GRANTS.BUSINESS_OPERATION_YEARS',
        subFilters: [
            {
                label: 'Less than 6 Months',
                labelBM: 'Kurang dari 6 bulan',
                filterBy: '06',
            },
            {
                label: '6 months to less than 1 year',
                labelBM: '6 bulan  hingga kurang dari 1 tahun',
                filterBy: '61',
            },
            {
                label: '1 year to less than 2 years',
                labelBM: '1 tahun hingga kurang dari 2 tahun',
                filterBy: '12',
            },
            {
                label: '2 years to less than 3 years',
                labelBM: '2 tahun hingga kurang dari 3 tahun',
                filterBy: '23',
            },
            {
                label: '3 years to less than 4 years',
                labelBM: '3 tahun hingga kurang dari 4 tahun',
                filterBy: '24',
            },
            {
                label: '4 years and above',
                labelBM: '4 tahun dan ke atas',
                filterBy: '40',
            },
        ],
    },
    {
        id: 'ag',
        name: 'GRANTS.AGENCY',
        subFilters: [
            { label: 'All', labelBM: 'Semua', filterBy: 'All' },
        ],
    },
    {
        id: 'ind',
        name: 'GRANTS.INDUSTRY',
        subFilters: [
            { label: 'All', labelBM: 'Semua', filterBy: 'All' },
            { label: 'Energy', labelBM: 'Tenaga', filterBy: '001' },
            { label: 'Education', labelBM: 'Pendidikan', filterBy: '002' },
            {
                label: 'Food and Beverage',
                labelBM: 'Makanan dan Minuman',
                filterBy: '003',
            },
            {
                label: 'Agriculture and Forestry',
                labelBM: 'Pertanian dan Perhutanan',
                filterBy: '004',
            },
            {
                label: 'Environment and Biodiversity',
                labelBM: 'Persekitaran dan Biokepelbagaian',
                filterBy: '005',
            },
            {
                label: 'Smart Cities and Transportation',
                labelBM: 'Bandar Pintar dan Pengangkutan',
                filterBy: '006',
            },
            {
                label: 'Medical and Healthcare',
                labelBM: 'Perubatan dan Penjagaan Kesihatan',
                filterBy: '007',
            },
            {
                label: 'Culture, Arts and Tourism',
                labelBM: 'Budaya, Seni dan Pelancongan',
                filterBy: '008',
            },
            {
                label: 'Business and Financial Services ',
                labelBM: 'Perkhidmatan Perniagaan dan Kewangan',
                filterBy: '009',
            },
            {
                label: 'Technologies and Intelligent',
                labelBM: 'Teknologi dan Intelektual',
                filterBy: '010',
            },
            { label: 'Hospitality', labelBM: 'Hospitaliti', filterBy: '011' },
            {
                label: 'Oil & Gas Services',
                labelBM: 'Perkhidmatan Minyak dan Gas',
                filterBy: '012',
            },
            {
                label: 'Global Establishment',
                labelBM: 'Penubuhan Global',
                filterBy: '013',
            },
            {
                label: 'Research & Development',
                labelBM: 'Penyelidikan dan Pembangunan',
                filterBy: '014',
            },
            {
                label: 'Other services',
                labelBM: 'Lain-lain Perkhidmatan',
                filterBy: '015',
            },
        ],
    },
    {
        id: 'fa',
        name: 'GRANTS.FUNDING_AMOUNT',
        subFilters: [
            { label: 'All', labelBM: 'Semua', filterBy: 'All' },
            {
                label: 'RM 50,000 - RM 200,000',
                labelBM: 'RM 50,000 - RM 200,000',
                filterBy: '52',
            },
            {
                label: 'RM 200,001 -  RM 300,000',
                labelBM: 'RM 200,001 -  RM 300,000',
                filterBy: '23',
            },
            {
                label: 'RM 300,001 - RM 500,000',
                labelBM: 'RM 300,001 - RM 500,000',
                filterBy: '35',
            },
            {
                label: 'RM 500,001 - RM 600,000',
                labelBM: 'RM 500,001 - RM 600,000',
                filterBy: '56',
            },
            {
                label: 'RM 600,001 and above',
                labelBM: 'RM 600,001 dan ke atas',
                filterBy: '67',
            },
        ],
    },
];
